import Character from "./character";

export default class Player {
    id!: string;
    userId!: string;
    sessionId!: string;
    characterId!: string;
    companions: Character[] = [];

    constructor(data?: any) {
        if (data) {
            if (typeof data !== "object") data = JSON.parse(data);
            Object.assign(this, data);
            this.companions = Array.isArray(data.companions)
                ? data.companions.map((companion: any) => new Character(companion))
                : [];
        } else {
        }
    }
}
